export enum DrawBudgetLineCategory {
    LandPurchase = 1,
    SiteWork = 2,
    Foundation = 3,
    Framing = 4,
    ExteriorFinishes = 5,
    MajorSystemRoughIns = 6,
    InteriorFinishes = 7,
    FinalSteps = 8,
    Other = 9,
}

export const DrawBudgetLineCategoryDescription = [
    '',
    'Land Cost',
    'Site Work',
    'Foundation',
    'Framing',
    'Exterior Finishes',
    "Major System Rough-in's",
    'Interior Finishes',
    'Final Steps',
    'Other [optional]',
];
